export type FilePreviewType = 'pdf' | 'office' | 'other'

export interface FileIconInfo {
  label: string
  color: string
}

export const FILE_ICON_MAP: Record<string, FileIconInfo> = {
  pdf: { label: 'PDF', color: '#e74c3c' },
  doc: { label: 'DOC', color: '#2b579a' },
  docx: { label: 'DOC', color: '#2b579a' },
  xls: { label: 'XLS', color: '#217346' },
  xlsx: { label: 'XLS', color: '#217346' },
  ppt: { label: 'PPT', color: '#d24726' },
  pptx: { label: 'PPT', color: '#d24726' },
  txt: { label: 'TXT', color: '#666666' },
  zip: { label: 'ZIP', color: '#f39c12' },
  rar: { label: 'RAR', color: '#f39c12' },
}

const OFFICE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']

export function getFileExtension(fileName: string): string {
  const match = fileName.match(/\.([^.]+)$/)
  return match ? match[1].toLowerCase() : ''
}

export function resolveFileDisplayName(url: string, fileName?: string): string {
  if (fileName) return fileName
  try {
    const pathname = new URL(url).pathname
    const name = pathname.split('/').pop()
    if (name) return decodeURIComponent(name)
  } catch {
    const parts = url.split('/')
    const name = parts[parts.length - 1]?.split('?')[0]
    if (name) return decodeURIComponent(name)
  }
  return '文件'
}

export function getFileIconInfo(displayName: string, msgType?: string): FileIconInfo {
  const ext = getFileExtension(displayName)
  if (msgType === 'pdf' && !ext) {
    return FILE_ICON_MAP.pdf
  }
  return FILE_ICON_MAP[ext] || { label: (ext || 'FILE').toUpperCase(), color: '#8c8c8c' }
}

export function getPreviewType(displayName: string, msgType?: string): FilePreviewType {
  if (msgType === 'pdf') return 'pdf'
  const ext = getFileExtension(displayName)
  if (ext === 'pdf') return 'pdf'
  if (OFFICE_EXTENSIONS.includes(ext)) return 'office'
  return 'other'
}

export function getOfficePreviewUrl(url: string): string {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`
}

function triggerBlobDownload(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = fileName
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(objectUrl)
}

function triggerLinkDownload(url: string, fileName?: string): void {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.target = '_blank'
  anchor.rel = 'noopener noreferrer'
  if (fileName) anchor.download = fileName
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

export async function downloadChatFile(url: string, fileName?: string): Promise<void> {
  const displayName = resolveFileDisplayName(url, fileName)

  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`download failed: ${response.status}`)
    }
    const blob = await response.blob()
    triggerBlobDownload(blob, displayName)
    return
  } catch {
    // fetch 失败时（如网络策略拦截）回退为直接打开链接
  }

  try {
    triggerLinkDownload(url, displayName)
  } catch {
    window.open(url, '_blank')
  }
}
